const geminiLanguageCatalog = [
  ['auto', 'Auto-detect (Auto switch)', '🌐'],
  ['iw', 'Hebrew', '🇮🇱'],
  ['af', 'Afrikaans', '🇿🇦'],
  ['sq', 'Albanian', '🇦🇱'],
  ['am', 'Amharic', '🇪🇹'],
  ['ar', 'Arabic', '🇸🇦'],
  ['hy', 'Armenian', '🇦🇲'],
  ['as', 'Assamese', '🇮🇳'],
  ['az', 'Azerbaijani', '🇦🇿'],
  ['eu', 'Basque', '🇪🇸'],
  ['be', 'Belarusian', '🇧🇾'],
  ['bn', 'Bengali', '🇧🇩'],
  ['bs', 'Bosnian', '🇧🇦'],
  ['bg', 'Bulgarian', '🇧🇬'],
  ['ca', 'Catalan', '🇪🇸'],
  ['ceb', 'Cebuano', '🇵🇭'],
  ['zh', 'Chinese (Simplified and Traditional)', '🇨🇳'],
  ['co', 'Corsican', '🇫🇷'],
  ['hr', 'Croatian', '🇭🇷'],
  ['cs', 'Czech', '🇨🇿'],
  ['da', 'Danish', '🇩🇰'],
  ['dv', 'Dhivehi', '🇲🇻'],
  ['nl', 'Dutch', '🇳🇱'],
  ['en', 'English', '🇺🇸'],
  ['eo', 'Esperanto', '🇪🇺'],
  ['et', 'Estonian', '🇪🇪'],
  ['fil', 'Filipino (Tagalog)', '🇵🇭'],
  ['fi', 'Finnish', '🇫🇮'],
  ['fr', 'French', '🇫🇷'],
  ['fy', 'Frisian', '🇳🇱'],
  ['gl', 'Galician', '🇪🇸'],
  ['ka', 'Georgian', '🇬🇪'],
  ['de', 'German', '🇩🇪'],
  ['el', 'Greek', '🇬🇷'],
  ['gu', 'Gujarati', '🇮🇳'],
  ['ht', 'Haitian Creole', '🇭🇹'],
  ['ha', 'Hausa', '🇳🇬'],
  ['haw', 'Hawaiian', '🇺🇸'],
  ['hi', 'Hindi', '🇮🇳'],
  ['hmn', 'Hmong', '🇱🇦'],
  ['hu', 'Hungarian', '🇭🇺'],
  ['is', 'Icelandic', '🇮🇸'],
  ['ig', 'Igbo', '🇳🇬'],
  ['id', 'Indonesian', '🇮🇩'],
  ['ga', 'Irish', '🇮🇪'],
  ['it', 'Italian', '🇮🇹'],
  ['ja', 'Japanese', '🇯🇵'],
  ['jv', 'Javanese', '🇮🇩'],
  ['kn', 'Kannada', '🇮🇳'],
  ['kk', 'Kazakh', '🇰🇿'],
  ['km', 'Khmer', '🇰🇭'],
  ['ko', 'Korean', '🇰🇷'],
  ['kri', 'Krio', '🇸🇱'],
  ['ku', 'Kurdish', '🇹🇯'],
  ['ky', 'Kyrgyz', '🇰🇬'],
  ['lo', 'Lao', '🇱🇦'],
  ['la', 'Latin', '🇻🇦'],
  ['lv', 'Latvian', '🇱🇻'],
  ['lt', 'Lithuanian', '🇱🇹'],
  ['lb', 'Luxembourgish', '🇱🇺'],
  ['mk', 'Macedonian', '🇲🇰'],
  ['mg', 'Malagasy', '🇲🇬'],
  ['ms', 'Malay', '🇲🇾'],
  ['ml', 'Malayalam', '🇮🇳'],
  ['mt', 'Maltese', '🇲🇹'],
  ['mi', 'Maori', '🇳🇿'],
  ['mr', 'Marathi', '🇮🇳'],
  ['mni-Mtei', 'Meiteilon (Manipuri)', '🇮🇳'],
  ['mn', 'Mongolian', '🇲🇳'],
  ['my', 'Myanmar (Burmese)', '🇲🇲'],
  ['ne', 'Nepali', '🇳🇵'],
  ['no', 'Norwegian', '🇳🇴'],
  ['ny', 'Nyanja (Chichewa)', '🇲🇼'],
  ['or', 'Odia (Oriya)', '🇮🇳'],
  ['ps', 'Pashto', '🇦🇫'],
  ['fa', 'Persian', '🇮🇷'],
  ['pl', 'Polish', '🇵🇱'],
  ['pt', 'Portuguese', '🇵🇹'],
  ['pa', 'Punjabi', '🇮🇳'],
  ['ro', 'Romanian', '🇷🇴'],
  ['ru', 'Russian', '🇷🇺'],
  ['sm', 'Samoan', '🇼🇸'],
  ['gd', 'Scots Gaelic', '🇬🇧'],
  ['sr', 'Serbian', '🇷🇸'],
  ['st', 'Sesotho', '🇱🇸'],
  ['sn', 'Shona', '🇿🇼'],
  ['sd', 'Sindhi', '🇵🇰'],
  ['si', 'Sinhala (Sinhalese)', '🇱🇰'],
  ['sk', 'Slovak', '🇸🇰'],
  ['sl', 'Slovenian', '🇸🇮'],
  ['so', 'Somali', '🇸🇴'],
  ['es', 'Spanish', '🇪🇸'],
  ['su', 'Sundanese', '🇮🇩'],
  ['sw', 'Swahili', '🇰🇪'],
  ['sv', 'Swedish', '🇸🇪'],
  ['tg', 'Tajik', '🇹🇯'],
  ['ta', 'Tamil', '🇮🇳'],
  ['te', 'Telugu', '🇮🇳'],
  ['th', 'Thai', '🇹🇭'],
  ['tr', 'Turkish', '🇹🇷'],
  ['uk', 'Ukrainian', '🇺🇦'],
  ['ur', 'Urdu', '🇵🇰'],
  ['ug', 'Uyghur', '🇨🇳'],
  ['uz', 'Uzbek', '🇺🇿'],
  ['vi', 'Vietnamese', '🇻🇳'],
  ['cy', 'Welsh', '🇬🇧'],
  ['xh', 'Xhosa', '🇿🇦'],
  ['yi', 'Yiddish', '🇮🇱'],
  ['yo', 'Yoruba', '🇳🇬'],
  ['zu', 'Zulu', '🇿🇦']
];

const languageAliases = {
  he: '🇮🇱',
  hebrew: '🇮🇱',
  'עברית': '🇮🇱',
  english: '🇺🇸',
  spanish: '🇪🇸',
  french: '🇫🇷',
  german: '🇩🇪',
  chinese: '🇨🇳',
  mandarin: '🇨🇳',
  japanese: '🇯🇵',
  korean: '🇰🇷',
  arabic: '🇸🇦',
  portuguese: '🇵🇹',
  italian: '🇮🇹',
  russian: '🇷🇺',
  hindi: '🇮🇳',
  turkish: '🇹🇷',
  dutch: '🇳🇱',
  polish: '🇵🇱',
  swedish: '🇸🇪',
  danish: '🇩🇰',
  finnish: '🇫🇮',
  norwegian: '🇳🇴',
  auto: '🌐',
  autodetect: '🌐',
  'auto-detect': '🌐',
  'auto detect': '🌐',
  'auto-detect (auto switch)': '🌐',
  'auto detect (auto switch)': '🌐'
};

function normalizeLanguageValue(value) {
  if (typeof value !== 'string') {
    return '';
  }
  return value.trim().toLowerCase().replace(/\s+/g, ' ');
}

function buildGeminiLanguageDetails() {
  const details = geminiLanguageCatalog.map(([code, name, flag]) => ({ code, name, flag }));
  return details.sort((left, right) => {
    if (left.code === 'auto') {
      return -1;
    }
    if (right.code === 'auto') {
      return 1;
    }
    if (left.name === 'Hebrew') {
      return -1;
    }
    if (right.name === 'Hebrew') {
      return 1;
    }
    return left.name.localeCompare(right.name);
  });
}

export const geminiLanguageDetails = buildGeminiLanguageDetails();
export const geminiLanguageNames = geminiLanguageDetails.map((language) => language.name);

const geminiLanguageFlagByCode = {};
const geminiLanguageFlagByName = {};
const geminiLanguageCodeByName = {
  chinese: 'zh',
  mandarin: 'zh',
  hebrew: 'he',
  'auto-detect (auto switch)': 'auto',
  'auto detect (auto switch)': 'auto',
  'auto-detect': 'auto',
  'auto detect': 'auto',
  autodetect: 'auto',
  auto: 'auto'
};

for (const language of geminiLanguageDetails) {
  geminiLanguageFlagByCode[normalizeLanguageValue(language.code)] = language.flag;
  geminiLanguageFlagByName[normalizeLanguageValue(language.name)] = language.flag;
  geminiLanguageCodeByName[normalizeLanguageValue(language.name)] = language.code;
}

for (const alias of Object.keys(languageAliases)) {
  geminiLanguageFlagByName[normalizeLanguageValue(alias)] = languageAliases[alias];
}

export function getLanguageFlag(language, code) {
  const normalizedCode = normalizeLanguageValue(code || '');
  if (normalizedCode !== '' && geminiLanguageFlagByCode[normalizedCode] !== undefined) {
    return geminiLanguageFlagByCode[normalizedCode];
  }

  const normalizedLanguage = normalizeLanguageValue(language || '');
  if (normalizedLanguage !== '' && geminiLanguageFlagByName[normalizedLanguage] !== undefined) {
    return geminiLanguageFlagByName[normalizedLanguage];
  }

  return '🌐';
}

export function getLocalizedLanguageName(language, locale) {
  const normalizedLanguage = normalizeLanguageValue(language);
  if (normalizedLanguage === '') {
    return '';
  }
  if (['auto', 'auto-detect', 'auto-detect (auto switch)', 'auto detect (auto switch)'].includes(normalizedLanguage) === true) {
    if (locale === 'he') {
      return 'זיהוי שפה אוטומטי (החלפה אוטומטית)';
    }
    return 'Auto-detect (Auto switch)';
  }
  const languageCode = geminiLanguageCodeByName[normalizedLanguage];
  if (typeof languageCode !== 'string' || languageCode === '') {
    return typeof language === 'string' ? language.trim() : '';
  }
  const languageLocale = typeof locale === 'string' && locale.trim() !== '' ? locale.trim() : 'en';
  if (typeof Intl !== 'object' || typeof Intl.DisplayNames !== 'function') {
    return typeof language === 'string' ? language.trim() : '';
  }
  try {
    const displayNames = new Intl.DisplayNames([languageLocale], { type: 'language' });
    const localizedName = displayNames.of(languageCode);
    if (typeof localizedName === 'string' && localizedName !== '') {
      return localizedName;
    }
  } catch (error) {
    return typeof language === 'string' ? language.trim() : '';
  }
  return typeof language === 'string' ? language.trim() : '';
}


